import { useTranslation } from "react-i18next";

import { StatusHeader } from "@shared/table/headers/StatusHeader";

type Props = {
    value: string[];
    onChange: (value: string[]) => void;
};

export const OtaStatusHeader = ({ value, onChange }: Props) => {
    const { t } = useTranslation(["common"]);
    const labels = {
        available: t("common:label.available"),
        deleted: t("common:label.deleted"),
        hidden: t("common:label.hidden"),
    };

    return <StatusHeader labels={labels} value={value} onChange={onChange} />;
};
